import React, { useState, useRef, useEffect } from 'react';
import ConfirmationModal from './ConfirmationModal';
import MenuDotsIcon from './icons/MenuDotsIcon';
import MenuDropdown from './column/MenuDropdown';
import { MenuContainer, MenuButton } from '../styles/ColumnMenu.styles';
import { useClickOutside } from '../hooks/useClickOutside';

const ColumnMenu = ({ column, onArchiveAll, onDeleteColumn, onExportList }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const menuRef = useRef();

    useClickOutside(menuRef, () => setIsOpen(false));

    const handleDeleteClick = () => {
        setIsOpen(false);
        setShowDeleteConfirmation(true);
    };

    const handleConfirmDelete = () => {
        onDeleteColumn();
        setShowDeleteConfirmation(false);
    };

    const getDeleteConfirmationMessage = () => {
        return column.cards?.length > 0
            ? "This list contains cards that will also be deleted. Are you sure you want to delete this list and all its cards?"
            : "Are you sure you want to delete this list?";
    };

    return (
        <MenuContainer ref={menuRef}>
            <MenuButton
                onClick={() => setIsOpen(!isOpen)}
                title="List actions"
            >
                <MenuDotsIcon />
            </MenuButton>

            {isOpen && (
                <MenuDropdown
                    onArchiveAll={onArchiveAll}
                    onDeleteClick={handleDeleteClick}
                    onExportList={onExportList}
                    setIsOpen={setIsOpen}
                />
            )}

            {showDeleteConfirmation && (
                <ConfirmationModal
                    title="Delete List"
                    message={getDeleteConfirmationMessage()}
                    onConfirm={handleConfirmDelete}
                    onCancel={() => setShowDeleteConfirmation(false)}
                />
            )}
        </MenuContainer>
    );
};

export default ColumnMenu;